import client from './client';

export const list = () => client.get('/users/').then(r => r.data);
export const create = (email, password) => client.post('/users/', { email, password }).then(r => r.data);
export const update = (id, body) => client.patch(`/users/${id}`, body).then(r => r.data);
export const remove = (id) => client.delete(`/users/${id}`);
